import capitalize from "lodash/capitalize";
import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { InputSize, InputType, TextAlign, ValidationStatus } from "common/components/input/types";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { TimeUnit, TimeUnitLabels } from "common/widgets/date-range-picker/models/types";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { MinMultiAttributionLookbackDays } from "./constants";
export function template() {
  const maxLookbackDays = this.getMaxLookbackDays();
  const invalidLookbackText = this.getInvalidLookbackText();
  return /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-content"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-title"
  }, "Lookback Window", /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-info-container"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  }), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { "max-width": `250px` }
  }, "The time window where a user's events with this attribution property are counted towards the calculation. The window ends when the conversion metric happens."))), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-body"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-value-section"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".multi-attribution-lookback-value",
    attrs: {
      size: InputSize.Large,
      type: InputType.Number,
      min: MinMultiAttributionLookbackDays.toString(),
      max: maxLookbackDays.toString(),
      "text-align": TextAlign.Center,
      "validation-status": invalidLookbackText ? ValidationStatus.Invalid : ValidationStatus.Default
    },
    on: { input: (ev) => this.handleLookbackDaysInput(ev) },
    props: {
      value: this.state.stagedLookbackDays
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-unit"
  }, capitalize(`${TimeUnitLabels[TimeUnit.Day]}s`))), invalidLookbackText && /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-error"
  }, invalidLookbackText)), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-footer"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-reset-button",
    attrs: {
      disabled: this.isDefaultLookbackDays(),
      theme: ButtonTheme.Tertiary
    },
    on: { click: () => this.handleClickReset() }
  }, "Reset"), /* @__PURE__ */ jsx("div", {
    sel: ".multi-attribution-lookback-core-buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-cancel-button",
    attrs: {
      theme: ButtonTheme.Tertiary
    },
    on: { click: () => this.dispatchCancel() }
  }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".multi-attribution-lookback-apply-button",
    attrs: {
      disabled: Boolean(invalidLookbackText),
      theme: ButtonTheme.Primary
    },
    on: { click: () => this.dispatchChange() }
  }, "Apply"))));
}
